import dayjs from "dayjs";
import { orderBy } from "lodash";

import {
  ICompanyLoanBid,
  IInvoicePurchaseBid,
  ILeasingBid,
  IRealEstateBid,
  IResolvedBid,
  IRevolvingCreditBid,
} from "../types/lenderResponse";

export interface ISortBidsBy {
  field: string;
  order: "asc" | "desc";
}

enum BID_TYPE {
  COMPANY_LOAN = "COMPANY_LOAN",
  FACTORING = "FACTORING",
  REAL_ESTATE = "REAL_ESTATE",
  LEASING = "LEASING",
  REVOLVING_CREDIT = "REVOLVING_CREDIT",
}

const sortBids = (
  bids:
    | ICompanyLoanBid[]
    | IRealEstateBid[]
    | ILeasingBid[]
    | IRevolvingCreditBid[]
    | IInvoicePurchaseBid[],
  sortBy: ISortBidsBy,
) => {
  return orderBy<IResolvedBid>(
    bids,
    (b) => {
      try {
        if (sortBy.field === "paybackTimeMonths" && "paybackTimeMonths" in b) {
          // Also use timestamp to keep sorting consistent over different bids
          const timestamp = dayjs(b.createdAt).unix();
          const sortValue = `${b.paybackTimeMonths}${timestamp}`;

          return parseFloat(sortValue);
        } else if (sortBy.field === "attractivenessScore") {
          if (b.lenderResponse.attractivenessScore === undefined) {
            return 0;
          } else {
            return b.lenderResponse.attractivenessScore;
          }
        }

        if (sortBy.field in b) {
          return parseFloat(
            b[sortBy.field as keyof IResolvedBid] as unknown as string,
          );
        } else {
          return 0;
        }
      } catch (e) {
        return b[sortBy.field as keyof IResolvedBid];
      }
    },
    sortBy.order,
  );
};

export { BID_TYPE, sortBids };
